import { h } from 'preact';

const Placements = ({ placements, currentPlacement, onChangeHandler }) => (
  <div className="border border-1 border-x-0 border-t-0 border-gray-300 pb-5 mb-5">
    <div className="body-3 mb-2.5">Placement</div>
    <fieldset className="flex gap-4">
      {placements.map((placement, index) => (
        <div className="flex items-center mb-2.5 cursor-pointer" key={index}>
          <input
            type="checkbox"
            id={placement.label}
            className="checkbox--custom-no-checkmark"
            name="placement"
            value={placement.label}
            checked={currentPlacement.label === placement.label}
            onChange={() => onChangeHandler(placement)}
          />
          <label className="ml-2.5 body-3" htmlFor={placement.label}>
            {placement.label}
          </label>
        </div>
      ))}
    </fieldset>
  </div>
);

export default Placements;
